// @ts-check

/**
 * Bar that appears above a list once rows are selected. Renders nothing at zero.
 * Children are the action buttons; use `BulkActionBar.Button` for a consistent look.
 * @param {{ count: number, onClear: () => void, children: React.ReactNode }} props
 */
const BulkActionBar = ({ count, onClear, children }) => {
  if (count === 0) return null;
  return (
    <div className="sticky top-0 z-20 bg-gray-900 text-white dark:bg-gray-800 dark:border dark:border-border rounded-lg px-4 py-3 mb-4 flex flex-wrap items-center gap-3 shadow-md">
      <span className="text-sm font-medium">{count} selected</span>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      <button type="button" onClick={onClear} className="ml-auto text-xs text-gray-300 hover:text-white underline">
        Clear
      </button>
    </div>
  );
};

const TONES = {
  default: 'bg-white/10 hover:bg-white/20 text-white',
  danger: 'bg-red-600 hover:bg-red-700 text-white',
};

/**
 * @param {{ onClick: () => void, tone?: keyof typeof TONES, disabled?: boolean, children: React.ReactNode }} props
 */
BulkActionBar.Button = ({ onClick, tone = 'default', disabled = false, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`px-3 py-1.5 pointer-coarse:py-2.5 text-xs font-medium rounded-md disabled:opacity-50 ${TONES[tone]}`}
  >
    {children}
  </button>
);

export default BulkActionBar;
